// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1zWhY","actionsCol":"EnrolledClinics_actionsCol__27kWk"};